module.exports = __webpack_public_path__ + "img/verkehrszentrale_niedersachsen.48a881b4.png";